// extracted by mini-css-extract-plugin
module.exports = {"subsOfferInfo":"subsOfferInfo___1mF7_","offerInfo":"offerInfo___E9Izt","custAttrCom":"custAttrCom___1o_h0","offerStepBtn":"offerStepBtn___2YD1k","subBtns":"subBtns___2L1_a"};